module.exports = __webpack_public_path__ + "85d48f8146a806c7df03081c701ddc97.pdf";